import {
    FETCH_NOTIFICATION_COUNTS,
    UPDATE_NOTIFICATION_COUNTS,
} from "../actions/action.types";

interface InitialStateType {
    notification: number;
    meeting: {
        count: number;
        generalUnreadCount: number;
        specificUnreadCount: number;
    };
}

const initialState: InitialStateType = {
    notification: 0,
    meeting: {
        count: 0,
        generalUnreadCount: 0,
        specificUnreadCount: 0
    }
};

const notificationReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_NOTIFICATION_COUNTS:
            return payload
        case UPDATE_NOTIFICATION_COUNTS:
            return { ...state, ...payload }
        default:
            return state;
    }
};

export default notificationReducer;
